/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartsubtitle3Inputs */

const en_eventaistartsubtitle3 = /** @type {(inputs: Eventaistartsubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the link to the event page, describe it in a sentence or add a picture of the flyer. Pulsify fills in the rest.`)
};

const de_eventaistartsubtitle3 = /** @type {(inputs: Eventaistartsubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füg den Link zur Eventseite ein, beschreib es in einem Satz oder leg ein Bild vom Flyer dazu. Den Rest füllt Pulsify aus.`)
};

/**
* | output |
* | --- |
* | "Paste the link to the event page, describe it in a sentence or add a picture of the flyer. Pulsify fills in the rest." |
*
* @param {Eventaistartsubtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartsubtitle3 = /** @type {((inputs?: Eventaistartsubtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartsubtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartsubtitle3(inputs)
	return de_eventaistartsubtitle3(inputs)
});
export { eventaistartsubtitle3 as "eventAiStartSubtitle" }